<template>
    <div class="m-video">
        <h5 class="title"></h5>

        <div class="view">
            <div class="swiper" v-if="ready">
                <swiper ref="interSwiper" :options="swiperOptions">
                    <swiper-slide
                    v-for="(item,index) in list"
                    :key="index"
                    >
                        <a :href="item.url" target="_blank">
                            <div class="video-item"><img :src="item.logo" :alt="item.title" srcset=""></div>
                            <div class="video-title">{{ item.title }}</div>
                        </a>
                    </swiper-slide>                    
                </swiper>

                <!-- Add Arrows -->
                <div class="btn-next u-btn" @click='swiperNext' v-if="cnt < page"></div>
                <div class="btn-prev u-btn" @click='swiperPrev' v-if="cnt != 1"></div>

            </div>

            <loading v-else/>        
        </div>
    </div>
</template>

<script>
export default {
    data (){
        return {
            list : [],
            ready : false,
            swiperOptions: {
                slidesPerView: 4,
                slidesPerColumn: 2,
                paginationClickable: true,
                spaceBetween: 30                
            },
            cnt : 1,
            page : 1,            
        }
    },
    props :{
        'active' : {
            default : false,
        }
    },
    created (){
        // this.render_live();
        // this.render_news();
    },
    computed: {
        swiper() {
            return this.$refs.interSwiper.swiper
        }
    },    
    watch : {
        active (val){
            if(val && !this.ready){
                this.render();             
            }
        },
    },
    methods : {
        render(){
            this.$axios.get(this.$ajax_url_map.video)
            .then(
                res => {
                    this.list = res
                    this.ready = true
                    this.page = Math.ceil(this.list.length/8)
                },
                rej => {}
            )            
        },
        swiperNext() {
            this.cnt++;
            this.$refs.interSwiper.swiper.slideNext()
        },
        swiperPrev() {
            this.cnt--;
            this.$refs.interSwiper.swiper.slidePrev()
        },        
    },
}
</script>

<style scoped>
    .m-video{
        margin-top: 120px;
    }

    .title{
        width: 238px;
        height: 56px;
        margin-bottom: 65px;
        background-image: url(~@/assets/images/video/title.png);        
    }

    .m-video .view{
        position: relative;
        margin: 0 70px;
        min-height: 428px;
    }

    .swiper{
        position: relative;
    }

    .swiper a{
        display: block;
        margin-bottom: 30px;
    }

    .swiper .video-title{
        width: 295px;
        margin:12px auto 0;        
        font-size: 14px;
        color: #fff;
        transition: all .3s ease-in;
    }

    .swiper a:hover .video-title{
        color: #e8d39c;
    }

    .video-item{
        position: relative;
        width: 295px;
        height: 166px;
        margin: 0 auto;
        background-color: #0a233b;
        overflow: hidden;
    }

    .video-item img{
        width: 100%;
    }

    .video-item::after{
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 63px;
        height: 70px;
        background-image: url(~@/assets/images/video/icon-player.png);
    }

    .btn-prev{
        position: absolute;
        left: -70px;
        top: 50%;
        width: 47px;
        height: 59px;
        transform: translateY(-50%);
        background-image: url(~@/assets/images/video/btn-prev.png);
    }    

    .btn-next{
        position: absolute;
        right: -70px;
        top: 50%;
        width: 47px;
        height: 59px;
        transform: translateY(-50%);
        background-image: url(~@/assets/images/video/btn-next.png);
    }
</style>


// WEBPACK FOOTER //
// src/components/page/video.vue